import Picture from './common/Picture';

const ChildrenImages = (props) => {
  const { product, onImageClick } = props;

  if (product.images.length <= 1) {
    return null;
  }

  return (
    <div className="c7-product-detail__photo__thumbs">
      {product.images.map((image, index) => {
        const handleClick = (e) => {
          e.preventDefault();
          onImageClick(index);
        };
        // TODO Tyson accessibility of link
        return (
          <a key={image.id} href="" onClick={handleClick}>
            <Picture image={image} alt={product.title} size="small" />
          </a>
        );
      })}
    </div>
  );
};

export default ChildrenImages;
